import { jsx as _jsx } from "react/jsx-runtime";
import DesigningChart from './designing-chart.component';
var DesigningGraph = function (_a) {
    var _b, _c;
    var graphData = _a.graphData;
    var labData = ((_b = graphData === null || graphData === void 0 ? void 0 : graphData.dotRs) !== null && _b !== void 0 ? _b : [])
        .map(function (dot) { var _a, _b; return ({ x: (_a = dot.f) !== null && _a !== void 0 ? _a : 0, y: (_b = dot.r) !== null && _b !== void 0 ? _b : 0 }); })
        .sort(function (a, b) { return a.x - b.x; });
    var inSituData = ((_c = graphData === null || graphData === void 0 ? void 0 : graphData.deviationDots) !== null && _c !== void 0 ? _c : [])
        .map(function (dot) { var _a, _b; return ({ x: (_a = dot.f) !== null && _a !== void 0 ? _a : 0, y: (_b = dot.r) !== null && _b !== void 0 ? _b : 0 }); })
        .sort(function (a, b) { return a.x - b.x; });
    var defaultFrequencyLabels = [50, 80, 125, 200, 315, 500, 800, 1250, 2500, 3150, 5000];
    var graphSeries = graphData
        ? [
            { label: 'R (lab)', data: labData },
            { label: 'R (in situ)', data: inSituData },
        ]
        : [
            {
                label: 'Sound Reduction Index',
                data: defaultFrequencyLabels.map(function (f) { return ({ x: f, y: 0 }); }),
            },
            {
                label: 'Deviations',
                data: defaultFrequencyLabels.map(function (f) { return ({ x: f, y: 0 }); }),
            },
        ];
    return _jsx(DesigningChart, { graphSeries: graphSeries });
};
export default DesigningGraph;
